(function ($) {
  'use strict';

  $(document).on('click', '.js-video-play', function () {
    const $frame = $(this).closest('.js-video');

    if (!$frame.length) {
      return;
    }

    if ($frame.data('video-type') === 'embed') {
      const embed = String($frame.data('video-embed'));
      const separator = embed.indexOf('?') === -1 ? '?' : '&';

      $frame.html(
        '<iframe src="' +
          embed +
          separator +
          'autoplay=1" title="Video" ' +
          'allow="autoplay; fullscreen; picture-in-picture" ' +
          'allowfullscreen></iframe>'
      );

      return;
    }

    $frame.html(
      '<video src="' +
        String($frame.data('video-src')) +
        '" controls autoplay playsinline></video>'
    );
  });
})(jQuery);
